<template>
	<div v-if="game.hover_card" class="box hover">
		<div><p class="title">{{ game.hover_card[lang].name }}</p></div>
		<p v-show="game.hover_card[lang].effect" class="effect">{{ game.hover_card[lang].effect }}</p>
		<p v-show="game.hover_card[lang].description" class="description">{{ game.hover_card[lang].description }}</p>
		<p v-show="(game.hover_card.type == 'item' || game.hover_card.type == 'drop') && !game.hover_card.allow_multiple" class="description">{{ l.allow_once }}</p>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'hover',
	computed: Object.assign(mapGetters([ 'l', 'lang', 'game' ]), {

	}),
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.hover
	position absolute
	left 0
	top 0
	background-color dark
	padding-bottom 24px
	.title
		display inline-block
		margin 0 0 8px 0
		border-bottom 2px solid light
		line-height 1.25
		text-shadow 2px 2px dark, 2px -2px dark, -2px 2px dark, -2px -2px dark
	.description
		margin 0 0 8px 0
		color desaturate(darken(light, 40%), 50%)
		line-height 1.25
	.effect
		margin 0 0 8px 0
		padding-left 20px
		&:before
			content ''
			position absolute
			left 0
			top 6px
			width 8px
			height 8px
			background-color light
			margin 0 8px 0 0

</style>
